import pois from "./pois";
var watchPois = {


  watch6: {
    id: "watch6",
    name: "Apple Watch Series 6",
    product: true,
    html: "Watch6Page",
    videos: [],

    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3172.1285472343534,
        y: 967.8888802594298,
        z: -3858,
      },
      rotation: {
        w: 0.7044404754672442,
        x: -0.057924761491641885,
        y: -0.705016010952436,
        z: -0.057972086648089775
      },
      target: "image-product-watch6",
      fov: 60,
      wideFov: 48,
      interactive: false,
      clamped: true,
    },
  },
  watchSE: {
    id: "watchSE",
    name: "Apple Watch SE",
    product: true,
    html: "WatchSEPage",
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    camera: {
      position: {
        x: 3172.1285472343534,
        y: 967.8888802594298,
        z: -3200,
      },
      rotation: {
        w: 0.7044404754672442,
        x: -0.057924761491641885,
        y: -0.705016010952436,
        z: -0.057972086648089775
      },
      target: "image-product-watchSE",

      fov: 60,
      wideFov: 48,
      interactive: false,
      clamped: true,
    },
  },
};
export default watchPois;